import ItemInfos from '@/src/interfaces/catalog/item-infos'
import React from 'react'
import styles from './styles.module.scss'
import { useMerchant } from '@/src/context/merchant/merchant-context'

interface Props {
    itemOption: ItemInfos.ItemOption
    isCombo: boolean
    quantity: number
}

export default function AnswerPriceComponent(props: Props) {
    const { merchantSummary } = useMerchant()

    const itemOption = props.itemOption
    const quantity = props.quantity

    const renderItemPrice = (): JSX.Element => {
        const isObservationAnswer = !!itemOption.answerForCustomer && !!itemOption.answerForMerchant

        if (isObservationAnswer || props.isCombo || !merchantSummary?.showProductPrice) return <></>

        let price = 0
        let currentQuantity = quantity === 0 ? 1 : quantity

        if (itemOption.promoPrice === undefined) price = itemOption.itemChild?.salePrice ?? 0

        if (itemOption.promoPrice && itemOption.promoPrice > 0) price = itemOption.promoPrice

        if (price > 0)
            return <span className={styles.price}>+{(price * currentQuantity).toLocalePrice()}</span>

        return <></>
    }

    return renderItemPrice()
}
